import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import { NODE_TYPES } from '../Node/config';
import './style.css';

const NodeTypeSelect = props => {

    const labels = useMemo( () => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    [ selected, setSelected ] = useState( props.defaultValue || '' ),
    { onChange } = props;

    /**
     * @name onSelect
     * @function
     * @description Handles selection of a dropdown item
     * @param {EventListenerObject} e 
     */
    const onSelect = e => {
        setSelected( e.target.value );
        onChange( 'type', e.target.value );
    };

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale );
    }, [ labels, locale ]);

    return (
        <FormControl fullWidth className="coe__selectNodeType">
            <TextField
                label={ labels.nodeType }
                onChange={ onSelect }
                required
                select
                value={ selected }>
                {
                    NODE_TYPES.map(
                        ( type, index ) => (
                            <MenuItem key={ 'option-' + index } value={ type }>{ labels[ type ] }</MenuItem>
                        )
                    )
                }
            </TextField>
        </FormControl>
    )
}

NodeTypeSelect.defaultProps = {
    onChange: () => {}
}

NodeTypeSelect.propTypes = {
    defaultValue: PropTypes.oneOf( NODE_TYPES ),
    onChange: PropTypes.func
}

export default NodeTypeSelect;